<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Edit Industry {{ parentIndustry ? 'in ' + parentIndustry.name : '' }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div sxPadding="medium">
    <ion-list>
      <ion-item>
        <ion-label position="stacked">Name</ion-label>
        <ion-input [(ngModel)]='dto.name' (keyup.enter)='update()' [value]='industry?.name'></ion-input>
      </ion-item>
    </ion-list>
    <page-action>
      <super-button [action]='update'>Update</super-button>
    </page-action>
  </div>
</ion-content>
